import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ changesManagementId = '', ...params }) => {
  return await dponetAPI.get(`/changes_managements/${changesManagementId}`, {
    params,
  })
}

const create = async (data) => {
  return await dponetAPI.postForm('/changes_managements', {
    changesManagement: data,
  })
}

const update = async ({ changesManagementId = '', ...params }) => {
  return await dponetAPI.putForm(
    `/changes_managements/${changesManagementId}`,
    {
      changesManagement: params,
    },
  )
}

const softDelete = async ({ changesManagementId = '' }) => {
  return await dponetAPI.put(`/changes_managements/${changesManagementId}`)
}

const destroyPlanAction = async ({
  changesManagementId = '',
  evidencePlanActionId = '',
  planActionId = '',
}) => {
  return await dponetAPI.delete(
    `/changes_managements/${changesManagementId}/evidence_plan_actions/${evidencePlanActionId}/plan_actions/${planActionId}`,
  )
}

const destroyEvidencePlanAction = async ({
  changesManagementId = '',
  evidencePlanActionId = '',
}) => {
  return await dponetAPI.delete(
    `/changes_managements/${changesManagementId}/evidence_plan_actions/${evidencePlanActionId}`,
  )
}

const removeEvidenceDocument = async ({
  changesManagementId = '',
  evidencePlanActionId = '',
  documentId = '',
}) => {
  return await dponetAPI.delete(
    `/changes_managements/${changesManagementId}/evidence_plan_actions/${evidencePlanActionId}/document/${documentId}`,
  )
}

export default {
  get,
  create,
  update,
  softDelete,
  destroyPlanAction,
  destroyEvidencePlanAction,
  removeEvidenceDocument,
}
